var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTacometro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.464 25.258a1 1 0 10-1.732-1 1 1 0 001.732 1zm1.732 1a3 3 0 10-5.196-3 3 3 0 005.196 3z",
    fill: "url(#tacometro_svg__paint0_linear_1038_6693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.098 23.892a1 1 0 01-.365-1.366l5-8.66a1 1 0 011.732 1l-5 8.66a1 1 0 01-1.367.366z",
    fill: "url(#tacometro_svg__paint1_linear_1038_6693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.053 33.106a1 1 0 01.447-1.342l2.211-1.106a1 1 0 01.895 1.79l-2.212 1.105a1 1 0 01-1.341-.447z",
    fill: "url(#tacometro_svg__paint2_linear_1038_6693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.053 14.894a1 1 0 00.447 1.342l2.211 1.106a1 1 0 00.895-1.79l-2.212-1.105a1 1 0 00-1.341.447z",
    fill: "url(#tacometro_svg__paint3_linear_1038_6693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 4a1 1 0 011 1v6a1 1 0 11-2 0V5a1 1 0 011-1z",
    fill: "url(#tacometro_svg__paint4_linear_1038_6693)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.947 33.106a1 1 0 00-.447-1.342l-2.211-1.106a1 1 0 00-.895 1.79l2.212 1.105a1 1 0 001.341-.447z",
    fill: "url(#tacometro_svg__paint5_linear_1038_6693)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 42c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18zm0 2c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z",
    fill: "url(#tacometro_svg__paint6_linear_1038_6693)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.947 14.894a1 1 0 01-.447 1.342l-2.211 1.106a1 1 0 01-.895-1.79l2.212-1.105a1 1 0 011.341.447z",
    fill: "url(#tacometro_svg__paint7_linear_1038_6693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint0_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint1_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint2_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint3_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint4_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint5_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint6_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacometro_svg__paint7_linear_1038_6693",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgTacometro as ReactComponent };